
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import componentTitle from './componentTitle.vue';
    import defectList from './defectList.vue';

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    }

    interface State {
        titleText: string;
        titleData: TitleData;
        defectList: object[];
        listName: string;
        listDefectNumber: number;
        importantNumber: number;
        listSumNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "FireCheck",
        setup() {
            let state: State = reactive({
                titleText: '火烧检测',
                titleData: {
                    text: '标准说明',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    modelCnt: [
                        '【火烧检测标准】根据检测项目中是否出现烟熏、碳化、受热变形等状况，来判断是否有火烧车风险。',
                        'prop_up_height',
                        '【火烧车认定标准】减震器座、发动机舱、车身线束、发动机舱内管路、行李箱舱、存在烟熏、碳化、受热变形任一情况，即认定为火烧车。具体标准详见268V检测认证承诺书附件《268V检测认证标准》。'
                    ],
                },
                defectList: [],
                listName: '火烧检测',
                listDefectNumber: 0,
                importantNumber: 0,
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {fire} = data;
                const {importantItemCount,defectItemCount, itemCount, itemList, itemTitle} = fire
                state.defectList = itemList
                state.listName = itemTitle
                state.listDefectNumber = defectItemCount
                state.importantNumber = importantItemCount
                state.listSumNumber = itemCount
            })
            return {
                state
            }
        },
        components: {
            componentTitle, defectList
        }
    })
